import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Reviews = () => {
    const [reviews, setReviews] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const fetchReviews = async () => {
            const apiKey = 'YOUR_GOOGLE_API_KEY'; // Replace with your Google API Key
            const placeId = 'YOUR_PLACE_ID'; // Replace with your Google Place ID
            const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=reviews&key=${apiKey}`;

            try {
                if (apiKey === 'YOUR_GOOGLE_API_KEY' || placeId === 'YOUR_PLACE_ID') {
                    // Use dummy data if API keys are not provided
                    const dummyReviews = [
                        {
                            author_name: 'John Doe',
                            rating: 5,
                            text: 'Excellent service and quality!',
                        },
                        {
                            author_name: 'Jane Smith',
                            rating: 4.5,
                            text: 'Great experience, highly recommend!',
                        },
                        {
                            author_name: 'Alice Johnson',
                            rating: 4,
                            text: 'Good service, but room for improvement.',
                        },
                    ];
                    setReviews(dummyReviews);
                } else {
                    const response = await fetch(url);
                    const data = await response.json();

                    if (data.result && data.result.reviews) {
                        setReviews(data.result.reviews);
                    } else {
                        console.error('No reviews found or invalid response:', data);
                    }
                }
            } catch (error) {
                console.error('Error fetching reviews:', error);
            }
        };

        fetchReviews();
    }, []);

    const renderStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        return (
            <div className="flex">
                {Array(fullStars).fill(0).map((_, index) => (
                    <span key={`full-${index}`} className="text-yellow-400">★</span>
                ))}
                {halfStar && <span className="text-yellow-400">☆</span>}
                {Array(emptyStars).fill(0).map((_, index) => (
                    <span key={`empty-${index}`} className="text-gray-300">★</span>
                ))}
            </div>
        );
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [reviews]);

    return (
        <motion.div
            className="h-full flex flex-col justify-center items-center px-6 bg-secondary"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
        >
            {/* Header */}
            <div className="p-8 flex flex-col justify-start items-center gap-4">
                <div className="text-center">
                    <span className="text-primary text-2xl sm:text-3xl font-normal font-nunito-sans">
                        Why choose us?
                    </span>
                </div>
            </div>

            {/* Reviews Slider */}
            <motion.div
                className="py-4 flex flex-col sm:flex-row justify-center items-stretch gap-6 max-w-full sm:max-w-6xl"
                initial="hidden"
                animate="visible"
                variants={{
                    hidden: { opacity: 0, scale: 0.8 },
                    visible: { opacity: 1, scale: 1 },
                }}
                transition={{ duration: 0.5 }}
            >
                {[reviews[currentIndex - 1], reviews[currentIndex], reviews[(currentIndex + 1) % reviews.length]].map((review, index) => (
                    <motion.div
                        key={index}
                        className={`w-full sm:w-80 p-4 sm:p-6 bg-accent rounded-md flex flex-col justify-start items-start gap-4 sm:gap-6 shadow-md ${
                            index === 1
                                ? 'scale-110 opacity-100'
                                : 'opacity-50 hover:opacity-100 transition'
                        }`}
                        initial={{ opacity: 0, x: index === 1 ? 0 : (index === 0 ? -100 : 100) }}
                        animate={{ opacity: index === 1 ? 1 : 0.5, x: 0 }}
                        transition={{
                            duration: 0.5,
                        }}
                    >
                        <div className="flex items-center gap-4">
                            <div
                                className="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex justify-center items-center bg-primary text-white text-xl sm:text-2xl font-bold"
                            >
                                {review && review.author_name
                                    ? review.author_name.charAt(0).toUpperCase()
                                    : 'A'}
                            </div>
                            <div className="flex-1">
                                <div className="text-primary text-sm sm:text-base font-medium font-nunito-sans">
                                    {review && review.author_name ? review.author_name : 'Anonymous'}
                                </div>
                                {review && renderStars(review.rating)}
                            </div>
                        </div>
                        <div className="text-primary text-sm sm:text-base font-normal font-nunito-sans leading-relaxed">
                            "{review && review.text ? review.text : 'No review available'}"
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </motion.div>
    );
};

export default Reviews;
